import React, { useContext } from "react";
import { InlineMath } from "react-katex";
import { ThemeContext } from "../../context/ThemeContext";

export default function ProbabilityOutcomeTable({ rows, columns, getCellValue, isHighlighted, ariaLabel }) {
  const displayValue = value => typeof value === "number" ? <InlineMath math={String(value).replace(".", "{,}")} /> : value;
  const { theme = "dark" } = useContext(ThemeContext) || {};
  const borderColor = theme === "light" ? "#171717" : "#f8f8f8";
  const baseCell = {
    padding: "6px 10px",
    textAlign: "center",
    minWidth: 36,
    border: `1px solid ${borderColor}`,
  };
  const headingCell = {
    ...baseCell,
    fontWeight: 700,
    backgroundColor: "transparent",
    border: `2px solid ${borderColor}`,
  };

  return (
    <div style={{ width: "100%", margin: "12px 0", overflowX: "auto" }}>
      <table aria-label={ariaLabel} style={{ borderCollapse: "collapse", border: `2px solid ${borderColor}`, margin: "0 auto" }}>
        <thead>
          <tr>
            <th style={headingCell}></th>
            {columns.map((column, columnIndex) => (
              <th key={`column-${columnIndex}`} style={headingCell}>{displayValue(column)}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={`row-${rowIndex}`}>
              <th style={headingCell}>{displayValue(row)}</th>
              {columns.map((column, columnIndex) => {
                const highlighted = Boolean(isHighlighted?.(row, column, rowIndex, columnIndex));
                return (
                  <td
                    key={`cell-${rowIndex}-${columnIndex}`}
                    style={highlighted
                      ? {
                          ...baseCell,
                          backgroundColor: "#f5b04d",
                          color: "#171717",
                          fontWeight: 700,
                        }
                      : baseCell}
                  >
                    {displayValue(getCellValue(row, column, rowIndex, columnIndex))}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
